import React from "react";
import classnames from "classnames";

export type IconType =
  | "sort"
  | "import"
  | "sort-asc"
  | "sort-dsc"
  | "clear"
  | "find"
  | "white-clear"
  | "eye"
  | "eye-close"
  | "arrow-left"
  | "warn"
  | "logout"
  | "apply"
  | "delete"
  | "delete-red"
  | "loupe"
  | "btn-close"
  | "btn-open"
  | "arrow-right-black"
  | "arrow-bottom-black"
  | "settings"
  | "arrow-up"
  | "alert-informative-above"
  | "alert-informative-below"
  | "alert-critical-above"
  | "alert-critical-below"
  | "no-signal"
  | "export"
  | "big-import"
  | "success"
  | "arrow-top-black"
  | "person"
  | "percentage-up"
  | "info"
  | "zoom-in"
  | "zoom-out"
  | "alert-stable-parameter"
  | "update"
  | "percentage-down"
  | "cloud-failed"
  | "reload"
  | "cloud-success";

export interface IconProps {
  type: IconType;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export default function Icon(props: IconProps) {
  const { type, className, onClick } = props;
  return <div onClick={onClick} className={classnames("icon", className, type)} />;
}
